var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.896 1.604a.56.56 0 0 0-.793 0L7.356 3.35l.752.753.039.043 1.75-1.75a.56.56 0 0 0 0-.793M1.952 8.756l4.697-4.698.752.753.043.038-4.699 4.7-1.058.264zM8.396.896a1.561 1.561 0 1 1 2.208 2.208l-7.25 7.25-.098.098-.134.033-2.001.5-.809.202.203-.808.5-2 .034-.135.098-.097zM7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2m3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
    clipRule: "evenodd"
  })));
});
const SvgDraftsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDraftsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljg5NjQyIDEuNjAzNjNDOS42NzczMSAxLjM4NDY3IDkuMzIyMjEgMS4zODQ3NCA5LjEwMzE5IDEuNjAzNzhMNy4zNTU4OSAzLjM1MTNMOC4xMDgyMiA0LjEwMzYzQzguMTIyMDUgNC4xMTc0NyA4LjEzNDkgNC4xMzE5MSA4LjE0Njc3IDQuMTQ2ODdMOS44OTY1NSAyLjM5NzA5QzEwLjExNTcgMi4xNzc5NyAxMC4xMTU2IDEuODIyNjggOS44OTY0MiAxLjYwMzYzWk0xLjk1MTk3IDguNzU1ODhMNi42NDg4MiA0LjA1ODQ1TDcuNDAxMTEgNC44MTA3NEM3LjQxNDk1IDQuODI0NTcgNy40MjkzOCA0LjgzNzQyIDcuNDQ0MzUgNC44NDkzTDIuNzQ0OTYgOS41NDg2OEwxLjY4NzE3IDkuODEzTDEuOTUxOTcgOC43NTU4OFpNOC4zOTYwNCAwLjg5NjcxOUM5LjAwNTQ5IDAuMjg3MTk3IDkuOTkzNjEgMC4yODcwMDcgMTAuNjAzMyAwLjg5NjI5M0MxMS4yMTMyIDEuNTA1ODMgMTEuMjEzNCAyLjQ5NDQ2IDEwLjYwMzcgMy4xMDQyTDMuMzU0MTIgMTAuMzUzN0wzLjI1NjE3IDEwLjQ1MTdMMy4xMjE3OCAxMC40ODUzTDEuMTIwOCAxMC45ODUzTDAuMzEyMDEyIDExLjE4NzRMMC41MTQ1NzUgMTAuMzc4N0wxLjAxNTU1IDguMzc4NjlMMS4wNDkxNyA4LjI0NDQ5TDEuMTQ2OTkgOC4xNDY2NUw4LjM5NjA0IDAuODk2NzE5Wk03LjAwMDI5IDExLjAwMDJDNy41NTI1NyAxMS4wMDAyIDguMDAwMjkgMTAuNTUyNCA4LjAwMDI5IDEwLjAwMDJDOC4wMDAyOSA5LjQ0Nzg3IDcuNTUyNTcgOS4wMDAxNiA3LjAwMDI5IDkuMDAwMTZDNi40NDggOS4wMDAxNiA2LjAwMDI5IDkuNDQ3ODcgNi4wMDAyOSAxMC4wMDAyQzYuMDAwMjkgMTAuNTUyNCA2LjQ0OCAxMS4wMDAyIDcuMDAwMjkgMTEuMDAwMlpNMTAuMDAwMyAxMS4wMDAyQzEwLjU1MjYgMTEuMDAwMiAxMS4wMDAzIDEwLjU1MjQgMTEuMDAwMyAxMC4wMDAyQzExLjAwMDMgOS40NDc4NyAxMC41NTI2IDkuMDAwMTYgMTAuMDAwMyA5LjAwMDE2QzkuNDQ4IDkuMDAwMTYgOS4wMDAyOSA5LjQ0Nzg3IDkuMDAwMjkgMTAuMDAwMkM5LjAwMDI5IDEwLjU1MjQgOS40NDggMTEuMDAwMiAxMC4wMDAzIDExLjAwMDJaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";